import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GlobalFilterTypeHandle } from '../../../../context/types';
import { FilterTypes } from './types';

const StyledIconButton = styled(IconButton)`
  margin: 0;
  padding: 0;
  pointer-events: all !important;
`;

export const Reset = <T extends FilterTypes>({
  filterHandle,
}: {
  filterHandle: GlobalFilterTypeHandle<T>;
}) => {
  const { t } = useTranslation();
  const [state, dispatch] = filterHandle;
  return (
    <Tooltip title={t('common:dashboardSideBar.reset') ?? ''}>
      <StyledIconButton
        onClick={() => dispatch({ type: 'reset' })}
        aria-label={t('common:dashboardSideBar.reset')}
        style={{ paddingTop: '0.3em' }}
        disabled={!state.resetActive}
      >
        <SettingsBackupRestoreIcon data-cy="filter-reset" />
      </StyledIconButton>
    </Tooltip>
  );
};
